export { default } from './MainFooter';
